import React, { useEffect } from "react";
import { INextTerm } from "../../../../../models/dashboard/studentDashboard";
import { ROUTER_URL } from "../../../../../constants/routerUrl";
import { useNavigate } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { getPageBlockData } from "../../../../../common-functions/commonFunctions";
import { limit, pageBlockId } from "../../../../../constants/pageBlocks";
import { setAppsForTerm } from "../../../../../store/slices/master/appSlice";
import { setDescriptionText } from "../../../../../store/slices/common/commonSlice";
import { baseURL } from "../../../../../constants/commonConstants";
import { IApps } from "../../../../../models/master/apps";
import { getApps } from "../../../../../action/masters/appActionCreator";
import { getDescriptionText } from "../../../../../action/common/commonActionCreator";

const BetaNextTerm = (props: INextTerm) => {
  const {
    getAllApps,
    appsForTerm,
    snapShots,
    getDescriptionText,
    description,
  } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewALL = () => {
    navigate(ROUTER_URL.STUDENT_PLAN_NEXT_TERM);
  };

  const pageBlockData = getPageBlockData(snapShots, pageBlockId.planNextTerm);

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllApps(pageBlockId.planNextTerm, limit.four);
    }
    getDescriptionText(pageBlockId.planNextTerm);
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setAppsForTerm([]));
      dispatch(setDescriptionText([]));
    };
  }, []);
  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="planwrap">
          <div className="title">
            <h2>Plan your Next Term</h2>
            <a
              className={
                pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
              }
              title="View All"
              onClick={handleViewALL}
            >
              View All
            </a>
          </div>
          {pageBlockData?.displayOrNot && (
            <>
              {description?.description && (
                <p className="para-hide-2">{description.description}</p>
              )}
              <div className="row mt-3">
                {appsForTerm
                  ?.filter((app: IApps) => app.displayOrNot)
                  .map((app: IApps) => (
                    <div className="col-lg-12" key={app.id}>
                      <div className="btncard">
                        <a
                          href={app.url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <img src={baseURL + app.image} alt={app.name} />
                          <h3>{app.name}</h3>
                          <span>
                            <img
                              src="/assets/images/icon/arrow-right.svg"
                              alt="Arrow icon"
                            />
                          </span>
                        </a>
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllApps: (pageBlockId: number, noOfItems: number) =>
    getApps(undefined, pageBlockId, noOfItems),
  getDescriptionText: (pageBlockId: number) => getDescriptionText(pageBlockId),
};

function mapStateToProps(state: any) {
  return {
    appsForTerm: state.app.appsForTerm,
    description: state.common.descriptionText,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BetaNextTerm);
